import { ErrorHandler, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AppConfig } from './core/services/app-config.service';
import * as Sentry from '@sentry/angular';
import { createErrorHandler } from '@sentry/angular';

export const ERROR_KEY = 'errors';

@Injectable()
export class SentryErrorHandlerService implements ErrorHandler {
  constructor(private config: AppConfig) {
  }

  handleError(error: Error | HttpErrorResponse) {
    if (!!this.config.config.sentry && this.config.config.sentry.enabled && Sentry.getClient()) {
      createErrorHandler({
        showDialog: false,
      }).handleError(error);
    } else {
      throw error;
    }
  }

}
